// extracted by mini-css-extract-plugin
export var productImage = "_qw-1";
export var viewLink = "_qw-2";
export var wishlistItem = "_qw-0";